/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CatalogItem,
    CatalogItemFromJSON,
    CatalogItemFromJSONTyped,
    CatalogItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface Deal
 */
export interface Deal {
    /**
     * 
     * @type {number}
     * @memberof Deal
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof Deal
     */
    readonly user?: number;
    /**
     * 
     * @type {CatalogItem}
     * @memberof Deal
     */
    estate?: CatalogItem;
    /**
     * 
     * @type {number}
     * @memberof Deal
     */
    readonly appeal?: number;
    /**
     * 
     * @type {number}
     * @memberof Deal
     */
    readonly agreedContract?: number;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    readonly status?: DealStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    readonly stage?: DealStageEnum;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    readonly typeOfProperty?: DealTypeOfPropertyEnum;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    readonly basePaymentType?: DealBasePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    readonly additionalPaymentType?: DealAdditionalPaymentTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof Deal
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Deal
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    readonly amoStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    readonly number?: string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    readonly date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Deal
     */
    readonly dutyPaid?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Deal
     */
    readonly paymentPeriod?: number;
    /**
     * 
     * @type {number}
     * @memberof Deal
     */
    readonly paymentInitialFee?: number;
    /**
     * 
     * @type {number}
     * @memberof Deal
     */
    readonly paymentMonthly?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Deal
     */
    readonly noteSend?: boolean;
}

export function DealFromJSON(json: any): Deal {
    return DealFromJSONTyped(json, false);
}

export function DealFromJSONTyped(json: any, ignoreDiscriminator: boolean): Deal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'estate': !exists(json, 'estate') ? undefined : CatalogItemFromJSON(json['estate']),
        'appeal': !exists(json, 'appeal') ? undefined : json['appeal'],
        'agreedContract': !exists(json, 'agreedContract') ? undefined : json['agreedContract'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'stage': !exists(json, 'stage') ? undefined : json['stage'],
        'typeOfProperty': !exists(json, 'typeOfProperty') ? undefined : json['typeOfProperty'],
        'basePaymentType': !exists(json, 'basePaymentType') ? undefined : json['basePaymentType'],
        'additionalPaymentType': !exists(json, 'additionalPaymentType') ? undefined : json['additionalPaymentType'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'amoStatus': !exists(json, 'amoStatus') ? undefined : json['amoStatus'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'dutyPaid': !exists(json, 'dutyPaid') ? undefined : json['dutyPaid'],
        'paymentPeriod': !exists(json, 'paymentPeriod') ? undefined : json['paymentPeriod'],
        'paymentInitialFee': !exists(json, 'paymentInitialFee') ? undefined : json['paymentInitialFee'],
        'paymentMonthly': !exists(json, 'paymentMonthly') ? undefined : json['paymentMonthly'],
        'noteSend': !exists(json, 'noteSend') ? undefined : json['noteSend'],
    };
}

export function DealToJSON(value?: Deal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'estate': CatalogItemToJSON(value.estate),
    };
}

/**
* @export
* @enum {string}
*/
export enum DealStatusEnum {
    New = 'new',
    Complete = 'complete',
    Canceled = 'canceled'
}
/**
* @export
* @enum {string}
*/
export enum DealStageEnum {
    Booking = 'booking',
    TypeOfOwnership = 'type_of_ownership',
    LoadOwners = 'load_owners',
    PayOptions = 'pay_options',
    LoadPayData = 'load_pay_data',
    Agreement = 'agreement',
    SigningOptions = 'signing_options',
    CheckContractSigned = 'check_contract_signed',
    PayStateDuty = 'pay_state_duty',
    Transaction = 'transaction',
    PayUnderContract = 'pay_under_contract',
    Final = 'final',
    SendDealData = 'send_deal_data'
}
/**
* @export
* @enum {string}
*/
export enum DealTypeOfPropertyEnum {
    Single = 'single',
    Spouses = 'spouses',
    SpousesSingle = 'spouses_single',
    SharedOwnership = 'shared_ownership',
    SharedOwnershipWithChildren = 'shared_ownership_with_children'
}
/**
* @export
* @enum {string}
*/
export enum DealBasePaymentTypeEnum {
    Payment100 = 'payment_100',
    TradeIn = 'trade_in',
    Mortgage = 'mortgage',
    InstallmentPayment = 'installment_payment'
}
/**
* @export
* @enum {string}
*/
export enum DealAdditionalPaymentTypeEnum {
    Nope = 'nope',
    MaternalCapital = 'maternal_capital',
    HousingCertificate = 'housing_certificate',
    MilitaryCertificate = 'military_certificate'
}


